import React from 'react';
import './Commontyesplastip.css';
import Commpall from '../../../imgs/Commpallet.webp';

const Commontyesplastip = () => {
    return (
        <div className="Standardspl-container">
            <div className='Commontyespl'>
                <h2 className="Standardspl-title">Common Types of Plastic Pallets</h2>
                <p className="Standardspl-date">Dec. 9, 2022</p>
                <div className="Commontyesp">
                    <img src={Commpall} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                </div>
                <p className="Standardspl-text">The various plastic pallets on the market,
                    do you know how to distinguish between them?</p>
                <p className="Standardspl-text">Firstly, according to the surface structure of the pallet, it is divided into flat pallets and grid pallets.
                    Secondly, according to the bottom structure of the pallet, it is divided into single-sided nine-legged, three-runner, six-runner pallets, and double-sided pallets.
                    And finally, according to the weight of plastic pallets, it can be divided into light pallets medium pallets and heavy pallets.</p>
                <p className="Standardspl-text">Flat pallets, which flat surfaces, smooth and easy to clean.
                    Grid pallets, the surface is fine grid, good ventilation.</p>
                <p className="Standardspl-text">In the daily handling turnover and storage of goods,
                    grid pallets are easy to deposit dust and product powder in the surface and voids,
                    not easy to clean. But in the same pallet size,
                    grid pallets use less material than flat pallets, and the price is more advantageous.</p>
            </div>

        </div>
    );
};

export default Commontyesplastip;
